// IT-1465: Add limit for `slugs` as URLS have a maximum length
// NOTE: The URL limit is much larger (2053 characters), but still nice to have
// a sane limit in our app
// https://stackoverflow.com/a/417184
export const MAX_SLUG_LENGTH = 256

// IT-2872: Add limit for (practice/user) names
export const MAX_NAME_LENGTH = 500

// Limit for input fields (to avoid spam/large text blobs)
export const MAX_INPUT_LENGTH = 1000

// Centralized minimum password length (for frontend and backend validation)
export const MIN_PASSWORD_LENGTH = 8

// Limit for the `search` query param
export const MAX_QUERY_LENGTH = 1000

// Limit age to a reasonable value
export const MAX_AGE_LIMIT = 150
